export default "__VITE_ASSET__DzzFYqXf__"